<template>
  <v-dialog width="375px" :value="show" @input="$emit('change', $event)">
    <v-card height="280px">
      <v-card-text class="h-100">
        <v-layout column class="h-100">
          <v-flex v-if="filteredSelect">
            <v-layout row wrap>
              <v-flex xs12 class="text-center">{{titleFilter}}</v-flex>
              <v-flex xs12 mt-3>
                <v-select
                  color="black"
                  :label="labelFilter"
                  v-model="valueFilter"
                  :items="itemsFilter"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="((filteredSelect) & (valueFilter == 0)) | (!filteredSelect)">
            <v-layout row wrap>
              <v-flex xs12 class="text-center" v-if="!filteredSelect">{{title}}</v-flex>
              <v-flex xs12 mt-3>
                <v-select color="black" :label="label" v-model="value" :items="items"></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-else>
            <v-layout row wrap>
              <v-flex xs12 class="text-center">
                <slot name="filteredHeader"></slot>
              </v-flex>
              <v-flex xs12 mt-3>
                <slot name="filteredContent"></slot>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <v-btn flat @click="$emit('change', false)">Cerrar</v-btn>
              <v-btn flat class="k-orange-linear-text" @click="download()">Descargar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    filteredSelect: {
      type: Boolean,
      default: false,
    },
    titleFilter: {
      type: String,
      default: 'Seleccione el tipo de reporte',
    },
    labelFilter: {
      type: String,
      default: 'Tipo de reporte',
    },
    itemsFilter: {
      type: Array,
    },
    title: {
      type: String,
      default: 'Seleccione el tipo de contactabilidad',
    },
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: 0,
      valueFilter: 0,
    };
  },
  methods: {
    download() {
      this.$emit('download', this.value, this.valueFilter);
      this.$emit('change', false);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/panelV2/DownloadModal.vue